import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import UnstyledButton from 'components/button/unstyled-button'
import { FiChevronLeft } from '@react-icons/all-files/fi/FiChevronLeft'
import { FiChevronRight } from '@react-icons/all-files/fi/FiChevronRight'
import raf from 'raf'
import { headerAnimationDuration } from '.'
import { useEffectOnce } from 'hooks/use-effect-once'
import { OutboundLink } from 'gatsby-plugin-google-gtag'
import noop from 'utils/noop'

let isSubscribed = false

const MobileNav = ({ active, setIsAnimating, ...props }) => {
  const [menuState, setMenuState] = useState(['mobile-nav-main-menu'])
  const [menuHidden, setMenuHidden] = useState(false)
  const [menuHeight, setMenuHeight] = useState(0)

  const currentMenuLevel = menuState.length
  const currentMenu = menuState[currentMenuLevel - 1]

  useEffectOnce(() => {
    isSubscribed = true

    return () => {
      isSubscribed = false
    }
  })

  const setHeight = (val, cb = noop) => {
    setMenuHeight(val)
    setIsAnimating(true)

    setTimeout(() => {
      if (isSubscribed) {
        cb()
        setIsAnimating(false)
      }
    }, headerAnimationDuration)
  }

  useEffect(() => {
    if (!active) {
      setHeight(0, () => {
        setMenuHidden(true)
      })
    } else {
      setMenuHidden(false)
    }
  }, [active])

  useEffect(() => {
    const currentMenuEl = document.getElementById(currentMenu)

    let newHeight
    ;(function getHeight() {
      newHeight = currentMenuEl.offsetHeight

      if (active) {
        if (newHeight === 0) {
          raf(() => {
            if (isSubscribed) {
              getHeight()
            }
          })
        } else {
          setHeight(newHeight)
        }
      }
    })()
  }, [active, menuState])

  const handleMenuForward = e => {
    const newMenuId = e.currentTarget.getAttribute('data-submenu-id')

    const newMenuState = [...menuState, newMenuId]

    setMenuState(newMenuState)
  }

  const handleMenuBackward = () => {
    const newMenuState = menuState.slice(0, currentMenuLevel - 1)

    setMenuState(newMenuState)
  }
  return (
    <MobileNavContainer
      className={menuHidden ? 'display-none' : ''}
      style={{ height: `${menuHeight}px` }}
      {...props}
    >
      <MobileNavList
        style={{
          transform: `translate3d(${
            currentMenu === 'main' ? '0' : `-${currentMenuLevel - 1}00%`
          }, 0, 0)`,
        }}
        id='mobile-nav-main-menu'
      >
        <LinkedListItem to='/'>Home</LinkedListItem>
        <li>
          <MobileNavSubMenuLink
            subMenuId='mobile-nav-equipment-submenu'
            onClick={handleMenuForward}
          >
            New Equipment
          </MobileNavSubMenuLink>
          <SubMenu
            label='Equipment'
            id='mobile-nav-equipment-submenu'
            currentMenu={currentMenu}
            currentMenuLevel={currentMenuLevel}
            menuLevel={2}
            handleMenuBackward={handleMenuBackward}
          >
            <li>
              <MobileNavSubMenuLink
                subMenuId='mobile-nav-john-deere-equipment-submenu'
                onClick={handleMenuForward}
              >
                John Deere Equipment
              </MobileNavSubMenuLink>
              <SubMenu
                label='John Deere Equipment'
                id='mobile-nav-john-deere-equipment-submenu'
                currentMenu={currentMenu}
                currentMenuLevel={currentMenuLevel}
                menuLevel={3}
                handleMenuBackward={handleMenuBackward}
              >
                <LinkedListItem to='/lawn-garden/'>Lawn &amp; Garden</LinkedListItem>
                <LinkedListItem to='/agriculture/'>Agriculture</LinkedListItem>
                <LinkedListItem to='/construction/'>Construction</LinkedListItem>
                <LinkedListItem to='/lawn-garden/compact-tractors/hutson-tractor-packages/'>
                  Tractor Packages
                </LinkedListItem>
                {/* <LinkedListItem href='https://build.hutsoninc.com'>Build Your Own</LinkedListItem> */}
                <LinkedListItem to='/government-sales/'>Government</LinkedListItem>
                <LinkedListItem to='/equipment/'>All Equipment</LinkedListItem>
              </SubMenu>
            </li>
            {/* <li>
              <LinkedListItem to='/used-equipment/'>Used Equipment</LinkedListItem>
            </li> */}
            <li>
              <MobileNavSubMenuLink
                subMenuId='mobile-nav-product-lines-submenu'
                onClick={handleMenuForward}
              >
                Product Lines
              </MobileNavSubMenuLink>
              <SubMenu
                label='Product Lines'
                id='mobile-nav-product-lines-submenu'
                currentMenu={currentMenu}
                currentMenuLevel={currentMenuLevel}
                menuLevel={3}
                handleMenuBackward={handleMenuBackward}
              >
                <LinkedListItem to='/manitou/'>Manitou</LinkedListItem>
                <LinkedListItem to='/stihl/'>STIHL</LinkedListItem>
                <LinkedListItem to='/product-lines/'>All Product Lines</LinkedListItem>
              </SubMenu>
            </li>
            <li>
              <MobileNavSubMenuLink
                subMenuId='mobile-nav-equipment-other-submenu'
                onClick={handleMenuForward}
              >
                Other
              </MobileNavSubMenuLink>
              <SubMenu
                label='Other'
                id='mobile-nav-equipment-other-submenu'
                currentMenu={currentMenu}
                currentMenuLevel={currentMenuLevel}
                menuLevel={3}
                handleMenuBackward={handleMenuBackward}
              >
                <LinkedListItem to='/implements/'>Implements</LinkedListItem>
                <LinkedListItem to='/government-sales/'>Government</LinkedListItem>
                <LinkedListItem to='/promotions/john-deere/'>John Deere Promotions</LinkedListItem>
              </SubMenu>
            </li>
          </SubMenu>
        </li>
        <LinkedListItem to='/used-equipment/'>Used Equipment</LinkedListItem>
        <li>
          <MobileNavSubMenuLink
            subMenuId='mobile-nav-parts-service-submenu'
            onClick={handleMenuForward}
          >
            Parts &amp; Service
          </MobileNavSubMenuLink>
          <SubMenu
            label='Parts &amp; Service'
            id='mobile-nav-parts-service-submenu'
            currentMenu={currentMenu}
            currentMenuLevel={currentMenuLevel}
            menuLevel={2}
            handleMenuBackward={handleMenuBackward}
          >
            <li>
              <MobileNavSubMenuLink
                subMenuId='mobile-nav-parts-submenu'
                onClick={handleMenuForward}
              >
                Parts
              </MobileNavSubMenuLink>
              <SubMenu
                label='Parts'
                id='mobile-nav-parts-submenu'
                currentMenu={currentMenu}
                currentMenuLevel={currentMenuLevel}
                menuLevel={3}
                handleMenuBackward={handleMenuBackward}
              >
                <LinkedListItem to='/parts/'>Parts at Hutson</LinkedListItem>
                <LinkedListItem href='https://shop.deere.com/us/?dealer-id=034321&CID=LNK_DLR_enUS_OS_HutsonWebsite'>
                  Shop Parts Online
                </LinkedListItem>
                <LinkedListItem to='/hutson-customer-portal/'>
                  Hutson Customer Portal
                </LinkedListItem>
                <LinkedListItem to='/promotions/parts/'>Parts Promotions</LinkedListItem>
              </SubMenu>
            </li>
            <li>
              <MobileNavSubMenuLink
                subMenuId='mobile-nav-service-submenu'
                onClick={handleMenuForward}
              >
                Service
              </MobileNavSubMenuLink>
              <SubMenu
                label='Service'
                id='mobile-nav-service-submenu'
                currentMenu={currentMenu}
                currentMenuLevel={currentMenuLevel}
                menuLevel={3}
                handleMenuBackward={handleMenuBackward}
              >
                <LinkedListItem to='/service/'>Service at Hutson</LinkedListItem>
                <LinkedListItem to='/service/schedule-service/'>Schedule Service</LinkedListItem>
                <LinkedListItem to='/service/inspections/'>Inspection Programs</LinkedListItem>
                <LinkedListItem to='/promotions/service/'>Service Promotions</LinkedListItem>
                <LinkedListItem to='/powergard/'>PowerGard Protection Plan</LinkedListItem>
                <LinkedListItem to='/sentry/'>Sentry Insurance</LinkedListItem>
              </SubMenu>
            </li>
            <li>
              <MobileNavSubMenuLink
                subMenuId='mobile-nav-support-submenu'
                onClick={handleMenuForward}
              >
                Support
              </MobileNavSubMenuLink>
              <SubMenu
                label='Support'
                id='mobile-nav-support-submenu'
                currentMenu={currentMenu}
                currentMenuLevel={currentMenuLevel}
                menuLevel={3}
                handleMenuBackward={handleMenuBackward}
              >
                <LinkedListItem to='/connected-support/'>Connected Support</LinkedListItem>
                <LinkedListItem to='/precision-ag/'>Precision Ag</LinkedListItem>
                <LinkedListItem to='/after-hours-support/'>After Hours Support</LinkedListItem>
              </SubMenu>
            </li>
          </SubMenu>
        </li>
        <li>
          <MobileNavSubMenuLink
            subMenuId='mobile-nav-resources-submenu'
            onClick={handleMenuForward}
          >
            Resources
          </MobileNavSubMenuLink>
          <SubMenu
            label='Resources'
            id='mobile-nav-resources-submenu'
            currentMenu={currentMenu}
            currentMenuLevel={currentMenuLevel}
            menuLevel={2}
            handleMenuBackward={handleMenuBackward}
          >
            <li>
              <MobileNavSubMenuLink
                subMenuId='mobile-nav-articles-submenu'
                onClick={handleMenuForward}
              >
                Articles
              </MobileNavSubMenuLink>
              <SubMenu
                label='Articles'
                id='mobile-nav-articles-submenu'
                currentMenu={currentMenu}
                currentMenuLevel={currentMenuLevel}
                menuLevel={3}
                handleMenuBackward={handleMenuBackward}
              >
                <LinkedListItem to='/blog/'>Blog</LinkedListItem>
                <LinkedListItem to='/knowledge-center/'>Knowledge Center</LinkedListItem>
                <LinkedListItem href='https://fieldguide.hutsoninc.com'>Field Guide</LinkedListItem>
              </SubMenu>
            </li>
            <li>
              <MobileNavSubMenuLink
                subMenuId='mobile-nav-reach-us-submenu'
                onClick={handleMenuForward}
              >
                Reach Us
              </MobileNavSubMenuLink>
              <SubMenu
                label='Reach Us'
                id='mobile-nav-reach-us-submenu'
                currentMenu={currentMenu}
                currentMenuLevel={currentMenuLevel}
                menuLevel={3}
                handleMenuBackward={handleMenuBackward}
              >
                <LinkedListItem to='/locations/'>Locations</LinkedListItem>
                <LinkedListItem to='/contact/'>Contact Us</LinkedListItem>
                <LinkedListItem to='/careers/'>Careers</LinkedListItem>
              </SubMenu>
            </li>
            <li>
              <MobileNavSubMenuLink
                subMenuId='mobile-nav-hutson-advantage-submenu'
                onClick={handleMenuForward}
              >
                The Hutson Advantage
              </MobileNavSubMenuLink>
              <SubMenu
                label='The Hutson Advantage'
                id='mobile-nav-hutson-advantage-submenu'
                currentMenu={currentMenu}
                currentMenuLevel={currentMenuLevel}
                menuLevel={3}
                handleMenuBackward={handleMenuBackward}
              >
                <LinkedListItem to='/about/'>About Us</LinkedListItem>
                <LinkedListItem to='/promotions/'>Promotions</LinkedListItem>
              </SubMenu>
            </li>
          </SubMenu>
        </li>
      </MobileNavList>
    </MobileNavContainer>
  )
}

const MobileNavContainer = styled.nav`
  background-color: #fff;
  display: block;
  overflow: hidden;
  position: relative;
  transition: ${props => props.theme.transition};

  @media (min-width: 900px) {
    display: none;
  }
`

const MobileNavList = styled.ul`
  background-color: #fff;
  display: block;
  height: auto;
  left: 0;
  list-style: none;
  margin: 0;
  max-height: 500px;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: ${props => props.theme.transition};

  > li {
    border-bottom: 1px solid ${props => props.theme.color.n40};
    display: block;
    margin: 0;
    padding: 0;
  }
`

const MobileNavLink = styled(UnstyledButton)`
  color: #161414;
  display: block;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.15;
  margin: 0;
  padding: 15px;
  position: relative;
  text-align: left;
  text-decoration: none;
  width: 100%;

  :hover,
  :focus {
    text-decoration: underline;
  }
`

const MobileNavLinkText = styled.span`
  display: inline-block;
  vertical-align: middle;
`

const MobileNavLinkIcon = styled(FiChevronRight)`
  color: #161414;
  display: inline-block;
  font-size: 16px;
  margin-top: 2px;
  position: absolute;
  right: 15px;
  vertical-align: middle;
`

const LinkedListItem = ({ children, to, href, ...props }) => {
  const linkProps = {}
  if (to) {
    linkProps.to = to
  }
  if (href) {
    linkProps.href = href
  }
  return (
    <li {...props}>
      <MobileNavLink as={to ? Link : OutboundLink} {...linkProps}>
        <MobileNavLinkText>{children}</MobileNavLinkText>
      </MobileNavLink>
    </li>
  )
}

const MobileNavSubMenuLink = ({ children, subMenuId, ...props }) => {
  return (
    <MobileNavLink data-submenu-id={subMenuId} {...props}>
      <MobileNavLinkText>{children}</MobileNavLinkText>
      <MobileNavLinkIcon aria-hidden='true' focusable='false' role='presentation' />
    </MobileNavLink>
  )
}
const SubMenu = ({
  children,
  currentMenu,
  currentMenuLevel,
  menuLevel,
  handleMenuBackward,
  id,
  label,
  ...props
}) => {
  const [active, setActive] = useState(false)

  useEffect(() => {
    if (currentMenu === id) {
      setActive(true)
    } else {
      if (currentMenuLevel < menuLevel) {
        setTimeout(() => {
          if (isSubscribed) {
            setActive(false)
          }
        }, headerAnimationDuration)
      }
    }
  }, [currentMenu, currentMenuLevel, id, menuLevel])

  return (
    <SubMenuList active={active} id={id} {...props}>
      <li>
        <SubMenuBackButtonContainer>
          <SubMenuBackButton onClick={handleMenuBackward}>
            <FiChevronLeft aria-hidden='true' focusable='false' role='presentation' />
          </SubMenuBackButton>
        </SubMenuBackButtonContainer>
        <SubMenuLabel>{label}</SubMenuLabel>
      </li>
      {children}
    </SubMenuList>
  )
}

const SubMenuList = styled(MobileNavList)`
  display: ${props => (props.active ? 'block' : 'none')};
  transform: translate3d(100%, 0, 0);
`

const SubMenuBackButtonContainer = styled.div`
  border-right: 1px solid ${props => props.theme.color.n40};
  display: inline-block;
  height: 100%;
`

const SubMenuBackButton = styled(UnstyledButton)`
  display: block;
  height: 100%;
  padding: 15px;

  svg {
    color: #161414;
    font-size: 16px;
    margin-top: 2px;
    vertical-align: middle;
  }
`

const SubMenuLabel = styled.span`
  color: #161414;
  display: inline-block;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.15;
  margin: 0;
  padding: 15px;
  position: relative;
  text-align: left;
  text-decoration: none;
  vertical-align: middle;
`

export default MobileNav
